export const aboutSSIContent = [
  {
    imgUrl: "/images/about/About-Us.jpg",
    imgAlt:
      "Luxury living room with quote - True hospitality consists of giving the best of yourself to your guests - Eleanor Roosavelt",
    heading: "About Us",
    paragraphs: [
      "Short Stays International is a boutique company specializing in Short-Term & Mid-Term Rental Management in the Greater Toronto Areas, Niagara Falls, Crystal Beach & Collingwood.",
      "We are not just a company, we are a team of people that care, that go beyond and above to ensure all guests receive a 5 star experience which helps owners maximize their revenue.",
      "Our team is comprised of Airbnb & VRBO Experienced Hosts, Communication Experts, Local Hosts Airbnb Cleaning Pros and Travel Pros in major areas like Toronto, Mississauga & Niagara Falls.",
      "As a boutique management firm, you are guaranteed a hands on approach that provides a full on service for your guests.",
    ],
  },
];
